import ReactInputMask from 'react-input-mask'

import { Checkbox, Flex, Input, Text } from '@chakra-ui/react'

import type React from 'react'
import type { FieldError, FieldValues, UseFormRegister } from 'react-hook-form'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  title: string
  name: string
  value: string
  isVehicle?: boolean
  isInternationalPlate?: boolean
  onToggleInternational?: (checked: boolean) => void
  register: UseFormRegister<FieldValues>
  // biome-ignore lint/suspicious/noExplicitAny: idk
  error?: FieldError | any
}

const SimpleInput = ({ title, register, name, error, value, isVehicle, isInternationalPlate, onToggleInternational }: Props) => {
  return (
    <Flex direction="column" gap="10px" w="100%" fontSize="10px" fontWeight="500">
      <Text fontSize={'xs'} fontWeight={'bold'} color="#000000">
        {title}
      </Text>

      {isVehicle && onToggleInternational && (
        <Checkbox
          size="md"
          borderColor="blue.600"
          colorScheme="blue"
          isChecked={isInternationalPlate}
          onChange={(e) => onToggleInternational(e.target.checked)}
        >
          Placa internacional
        </Checkbox>
      )}

      {isVehicle ? (
        <Flex position="relative" w="100%">
          <Input
            borderRadius="15px"
            errorBorderColor="#EB214E"
            isInvalid={Boolean(error)}
            borderWidth="2px"
            borderColor="#DDE4F1"
            bg="white"
            w="100%"
            h="55px"
            maxLength={onToggleInternational ? 7 : undefined}
            value={isVehicle ? value?.toUpperCase() : value}
            {...register(name)}
            autoComplete="off"
          />
          <Text position="absolute" top="30%" right="5%" color="#EB214E">
            {error?.message}
          </Text>
        </Flex>
      ) : (
        <Flex position="relative" w="100%">
          <Input
            as={ReactInputMask}
            mask={!isVehicle && '(99) 99999-9999'}
            errorBorderColor="#EB214E"
            isInvalid={Boolean(error)}
            borderRadius="15px"
            borderWidth="2px"
            borderColor="#DDE4F1"
            bg="white"
            h="55px"
            value={value}
            {...register(name)}
            autoComplete="off"
            _placeholderShown={{
              bg: 'red',
            }}
          />
          <Text position="absolute" top="30%" right="5%" color="#EB214E">
            {error?.message}
          </Text>
        </Flex>
      )}
    </Flex>
  )
}

export default SimpleInput
